import { PipesModule } from '../../../src/app/pipes/pipes.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SeekersService } from '../../app/pages/seekers/seekers.service'


import {
	NbActionsModule,
	NbCardModule,
	NbLayoutModule,
	NbMenuModule,
	NbRouteTabsetModule,
	NbSearchModule,
	NbSidebarModule,
	NbTabsetModule,
	NbThemeModule,
	NbUserModule,
	NbCheckboxModule,
	NbPopoverModule,
	NbContextMenuModule,
	NbProgressBarModule,
	NbCalendarModule,
	NbCalendarRangeModule,
	NbStepperModule,
	NbButtonModule,
	NbInputModule,
	NbAccordionModule,
	NbDatepickerModule,
	NbDialogModule,
	NbWindowModule,
	NbListModule,
	NbToastrModule,
	NbAlertModule,
	NbSpinnerModule,
	NbRadioModule,
	NbSelectModule,
	NbChatModule,
	NbTooltipModule,
	NbCalendarKitModule,
	NbIconModule,
	NbDateService,
} from '@nebular/theme';
import { NbMomentDateModule, NbMomentDateService } from '@nebular/moment';
import { NbSecurityModule } from '@nebular/security';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from '@app-stores/effects/auth.effects';
import { reducers } from '@app-stores/reducers/auth';
import {
	FooterComponent,
	HeaderComponent,
	SearchInputComponent,
	ThemeSettingsComponent,
	SwitcherComponent,
	LayoutDirectionSwitcherComponent,
	ThemeSwitcherComponent,
	TinyMCEComponent,
	ThemeSwitcherListComponent,
	ToggleSettingsButtonComponent,
} from './components';
import {
	CapitalizePipe,
	PluralPipe,
	RoundPipe,
	TimingPipe,
	NumberWithCommasPipe,
	EvaIconsPipe,
} from './pipes';
import {
	OneColumnLayoutComponent,
	SampleLayoutComponent,
	ThreeColumnsLayoutComponent,
	TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';

const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, PipesModule];

const NB_MODULES = [
	NbCardModule,
	NbLayoutModule,
	NbTabsetModule,
	NbRouteTabsetModule,
	NbMenuModule,
	NbUserModule,
	NbActionsModule,
	NbSearchModule,
	NbSidebarModule,
	NbCheckboxModule,
	NbPopoverModule,
	NbContextMenuModule,
	NbSecurityModule, // *nbIsGranted directive,
	NbProgressBarModule,
	NbCalendarModule,
	NbCalendarRangeModule,
	NbStepperModule,
	NbButtonModule,
	NbListModule,
	NbToastrModule,
	NbInputModule,
	NbAccordionModule,
	NbDatepickerModule,
	NbDialogModule,
	NbWindowModule,
	NbAlertModule,
	NbSpinnerModule,
	NbRadioModule,
	NbSelectModule,
	NbChatModule,
	NbTooltipModule,
	NbCalendarKitModule,
	NbIconModule,
	NbMomentDateModule
	];

	const COMPONENTS = [
	SwitcherComponent,
	LayoutDirectionSwitcherComponent,
	ThemeSwitcherComponent,
	ThemeSwitcherListComponent,
	HeaderComponent,
	FooterComponent,
	SearchInputComponent,
	ThemeSettingsComponent,
	TinyMCEComponent,
	OneColumnLayoutComponent,
	SampleLayoutComponent,
	ThreeColumnsLayoutComponent,
	TwoColumnsLayoutComponent,
	ToggleSettingsButtonComponent,
];

const ENTRY_COMPONENTS = [
  	ThemeSwitcherListComponent,
];

const PIPES = [
	CapitalizePipe,
	PluralPipe,
	RoundPipe,
	TimingPipe,
	NumberWithCommasPipe,
	EvaIconsPipe,
];

const NB_THEME_PROVIDERS = [
	...NbThemeModule.forRoot(
		{
		name: 'default',
		},
		[ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME ],
	).providers,
	...NbSidebarModule.forRoot().providers,
	...NbMenuModule.forRoot().providers,
	...NbDatepickerModule.forRoot().providers,
	...NbDialogModule.forRoot().providers,
	...NbWindowModule.forRoot().providers,
	...NbToastrModule.forRoot().providers,
	...NbChatModule.forRoot({
		messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
	}).providers,SeekersService,
	{ provide: NbDateService, useClass: NbMomentDateService }
];

@NgModule({
    imports: [...BASE_MODULES, ...NB_MODULES, StoreModule.forFeature('auth', reducers), EffectsModule.forFeature([AuthEffects])],
    exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES],
    declarations: [...COMPONENTS, ...PIPES]
})
export class ThemeModule {
	static forRoot(): ModuleWithProviders<ThemeModule> {
		return {
		ngModule: ThemeModule,
		providers: [...NB_THEME_PROVIDERS],
		};
	}
}
